import { FC, useEffect, useRef } from 'react';
export type ScriptComponentProps = {
  script?: string
}
const ScriptComponent: FC<ScriptComponentProps> = ({ script }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    //parse script string to html
    const parser = new DOMParser();
    const doc = parser.parseFromString(script, 'text/html');


    //find the script in the parse
    //render all the scripts in doc to the page
    const scripts = doc.getElementsByTagName('script');

    for (let i = 0; i < scripts.length; i++) {
      const scriptElement = document.createElement('script');
      const script = scripts[i];

      //set the attributes
      for (let j = 0; j < script.attributes.length; j++) {
        const attribute = script.attributes[j];
        scriptElement.setAttribute(attribute.name, attribute.value);
      }

      //set the inner html
      scriptElement.innerHTML = script.innerHTML;

      //append the script to the page
      ref.current.appendChild(scriptElement);
    }



  }, [script]);


  return (
    <>
      <div data-script-container ref={ref}></div>
    </>
  );
}

export default ScriptComponent
